<template>
  <div class="pbx-menu-item">
    <div :class="['pbx-menu-box', `pbx-menu-box--${type}`]">
      <tooltip
        placement="top"
        min-width="200"
        max-width="200"
        theme="light"
        :delay="1000"
        :transfer="true"
        :content="$t('pbx.worksheet.tooltips.drag_and_drop')"
      >
        <div class="pbx-menu-box__content">
          <img :src="`/img/icons/pbx/action-types/${type}.svg`" alt="" />
        </div>
      </tooltip>
    </div>

    <p class="pbx-menu-item__title">
      {{ $t(`pbx.worksheet.action.type.${type}`) }}
    </p>
  </div>
</template>
<script>
  export default {
    props: {
      type: {
        type: String,
        required: true
      }
    }
  };
</script>

<style lang="scss">
  .pbx-menu-item__title {
    text-align: center;
    margin-top: 10px;
    color: $text-color;
    font-size: 14px;
    font-weight: 700;
  }

  .pbx-menu-box {
    width: 82px;
    height: 82px;
    border-radius: 100%;
    border: 4px solid #ddd;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;

    @each $type, $color in $pbx-action-types {
      &--#{$type} {
        border-color: $color;
      }
    }

    &__content {
      background: #fff;
      width: 60px;
      height: 60px;
      border-radius: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.15), 4px 4px 4px 0 rgba(0, 0, 0, 0.15);
    }
  }
</style>
